import { css, cx } from '@bts-web/utils-style-engine';
import { ReactNode } from 'react';

const hiddenOnMobileStyles = css({
  display: { base: 'none', lg: 'block' },
});

export const AssetDetailsContainerInTradeWrapper = ({
  children,
  hideOnMobile,
}: {
  children: ReactNode;
  hideOnMobile?: boolean;
}) => (
  <div
    className={cx(
      css({
        width: '100%',
        flexGrow: '1',
        backgroundColor: 'neutrals.card_fill_primary',
      }),
      hideOnMobile && hiddenOnMobileStyles,
    )}
    data-testid="asset-details-content"
  >
    {children}
  </div>
);
